<template>
  <div class="inputShell temr">
    <div class="inputBox">
      <span v-if="params.title" :class="`title ${params.field}`">{{ params.title }}</span>
      <div class="inputItem">
        <input
          class="inputContainer"
          :readonly="params.disabled"
          :placeholder="params.props.placeholder"
          :maxlength="params.props.maxLength"
          @input="changeInput"
          v-model="value"
          type="text"
        />
        <div class="error" :style="{ color: 'red' }" v-if="error && value !== ''">{{ error }}</div>
      </div>
    </div>
    <van-icon v-if="!params.disabled && allowClearHandler && value" @click="allowClear" class="cross" name="cross" />
  </div>
</template>

<script>
export default {
  name: 'VerificationCode',
  data() {
    return {
      value: '',
      error: '',
      referrer: '',
    };
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  methods: {
    allowClear() {
      this.value = '';
      this.allowClearHandler();
    },
    changeInput(val) {
      this.value = JSON.stringify(val.target.value).replace(/[^0-9]/g, '');
    },
    // 获取邀请码
    getInvitedCodeFromProductId() {
      this.$api.CommonForms.getInvitedCodeFromProductId({
        productId: this.$route.query.productId,
      }).then((res) => {
        if (res && res.data) {
          // support 是否支持修改邀请码
          sessionStorage.setItem('invitationCodeObj', JSON.stringify(res.data))
          if (!res.data.support) {
            this.form.dispatch({
              type: 'upDateupDisabled',
              referrer: true,
            });
          }
          // inviteCode 设置邀请码
          this.form.setInitialValues({
            referrer: res.data.inviteCode || '',
          });
        }
      });
    },
  },
  mounted() {
    this.getInvitedCodeFromProductId(); 
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.$emit('input', val);
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val !== this.value) {
          this.value = val;
        }
      },
    },
    errorMessage: {
      handler(val) {
        this.error = val.message;
      },
    },
  },
};
</script>
<style scoped lang="scss">
.inputContainer {
  display: inline-block;
  border: none;
  font-size: 16px;
  flex: 1;
  padding: 0;
}
>>> input:disabled {
  background: #fff;
}
.allowClear {
  font-size: 14px;
  color: #999;
}
.inputShell {
  position: relative;
  padding: 10px 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputBox {
  background: #fff;
  flex: 1;
  display: flex;
  .inputItem {
    display: inline-block;
    position: relative;
    flex: 1;
    display: flex;
    .error {
      position: absolute;
      bottom: -12px;
    }
  }
}
.error {
  font-size: 12px;
}

.inputShell >>> input::-webkit-input-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #BCC2CC;
  line-height: 24px;
  font-weight: 400;
}
.inputShell >>> input::-moz-input-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #BCC2CC;
  line-height: 24px;
  font-weight: 400;
}
.inputShell >>> input::-ms-input-placeholder {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #BCC2CC;
  line-height: 24px;
  font-weight: 400;
}
.temr::after {
  // position: absolute;
  // right: 0;
  // bottom: 0;
  // left: 0;
  // margin: 0 16px;
  // box-sizing: border-box;
  // border-bottom: 1px solid #dddee1;
  // -webkit-transform: scaleY(0.5);
  // transform: scaleY(0.5);
  // content: ' ';
  // pointer-events: none;
}
.title {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #46494D;
  line-height: 21px;
  font-weight: 400;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  width: 86px;
  margin-right: 16px;
}
.cross {
  position: absolute;
  right: 16px;
  color: #9e9fa0;
}
</style>
